var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconFishColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00BCD4",
    d: "M14.36 7.54c-5.58 0-9.921 4.34-9.921 4.34l-1.86 1.24 1.86 1.333c2.497 1.78 5.592 4.248 9.921 4.248 4.341 0 10.54-4.34 10.54-6.201 0-1.86-6.199-4.96-10.54-4.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DD0E1",
    d: "M17.195 7.894a11.311 11.311 0 00-.975 4.606c0 1.995.572 3.92 1.488 5.541 3.193-1.105 7.192-3.786 7.192-5.541 0-1.755-4.339-3.885-7.705-4.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.561 11.26a1.241 1.241 0 11-2.482-.003 1.241 1.241 0 012.482.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006064",
    d: "M14.36 7.54c.89 0 1.858.13 2.835.354-.056-.305-.475-2.358-1.596-3.455-1.51.079-7.098 2.139-8.68 3.72.363.544.61.97.791 1.318 1.747-1.002 4.06-1.937 6.65-1.937zM.1 8.159c.618.62 1.24 3.518 1.24 4.962 0 1.432-.622 4.339-1.24 4.96 1.86-.621 3.843-2.646 4.32-3.642a.072.072 0 00.019.014l-1.24-1.332 1.24-1.242S3.199 9.401.1 8.16zm15.63 12.379c-2.556.095-3.014-.107-3.946-.288.583-1.13 4.002-4.302 4.624-3.981l-.055.293c.625.323-.038 2.846-.623 3.976z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0097A7",
    d: "M16.22 12.5c0-1.627.349-3.211.975-4.606a13.642 13.642 0 00-1.219-.22 12.289 12.289 0 00-.995 4.826c0 2.05.505 4.1 1.48 5.904.4-.11.857-.205 1.247-.365-.916-1.619-1.488-3.544-1.488-5.539z"
  }))));
}

export default SvgCommonIconFishColor;